import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import Container from '@material-ui/core/Container';
import Typography from '../components/Typography';
import consultoria from '../img/consultoria.webp';
import innovacion from '../img/innovacion.webp';
import estados from '../img/estadosContables.webp';
import mejoras from '../img/mejoraprocesos.webp';
import asociaciones from '../img/asociaciones.webp';
import tableros from '../img/tableros.webp';
import impositivo from '../img/asesoramientoImpositivo.webp';
import transformacion from '../img/transformacion.webp';
//import sistemas from '../img/sistemasInformacion.webp';
const styles = theme => ({
  root: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(4),
  },
  images: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexWrap: 'wrap',
  },
  imageWrapper: {
    position: 'relative',
    display: 'block',
    padding: 0,
    borderRadius: 0,
    height: '40vh',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      height: 200,
    },
    '&:hover': {
      zIndex: 1,
    },
    '&:hover $imageBackdrop': {
      opacity: 0.15,
    },
    '&:hover $imageMarked': {
      opacity: 0,
    },
    '&:hover $imageTitle': {
      border: '4px solid currentColor',
    },
  },
  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
  },
  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  },
  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    background: theme.palette.common.black,
    opacity: 0.5,
    transition: theme.transitions.create('opacity'),
  },
  imageTitle: {
    position: 'relative',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px 14px`,
  },
  imageMarked: {
    height: 3,
    width: 18,
    background: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
});

function ProductCategories(props) {
  const { classes } = props;

  const images = [
    {
      url: consultoria,
      title: 'Consultoria',
      width: '35%',
    },
    {
      url: innovacion,
      title: 'Mejora de Procesos',
      width: '35%',
    },
    {
      url: estados,
      title: 'Estados Contables y Auditoria',
      width: '30%',
    },
    {
      url: mejoras,
      title: 'Emprendimientos',
      width: '35%',
    },
    {
      url: asociaciones,
      title: 'Sociedades y Asociaciones',
      width: '35%',
    },
    {
      url: tableros,
      title: 'Tableros de Control',
      width: '30%',
    },
    {
      url: impositivo,
      title: 'Asesoramiento Impositivo',
      width: '50%',
    },
    {
      url: transformacion,
      title: 'Transformaciones digitales',
      width: '50%',
    },
  /* {
      url:sistemas,
      title: 'Desarrollo Sistemas de Informacion',
      width: '40%',
    },*/
  ];

  return (
    <Container id='servicios' className={classes.root} component="section">
      <Typography variant="h4" marked="center" align="center" component="h2">
        ¿Como podemos ayudar a tu empresa?
      </Typography>
      <div className={classes.images}>
        {images.map(image => (
          <ButtonBase
            key={image.title}
            className={classes.imageWrapper}
            style={{
              width: image.width,
            }}
          >
            <div
              className={classes.imageSrc}
              style={{
                backgroundImage: `url(${image.url})`,
              }}
            />
            <div className={classes.imageBackdrop} />
            <div className={classes.imageButton}>
              <Typography
                component="h3"
                variant="h6"
                color="inherit"
                className={classes.imageTitle}
              >
                {image.title}
                <div className={classes.imageMarked} />
              </Typography>
            </div>
          </ButtonBase>
        ))}
      </div>
    </Container>
  );
}

ProductCategories.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductCategories);
